<template>
  <main class="main-content" id="topDom">
    <section class="section --banner">
      <ul class="breadcrumb">
        <li class="breadcrumb__li --current">
          <router-link to="/" class="breadcrumb__link">{{ $t("i18n.home") }}</router-link>
        </li>
        <li class="breadcrumb__li --current">
          <router-link to="/VacuumValveMain" class="breadcrumb__link">{{ form.pathName }}</router-link>
        </li>
        <li class="breadcrumb__li">
          <span class="breadcrumb__text">{{ form.lastPathName }}</span>
        </li>
      </ul>
      <div class="banner">
        
        <div class="banner__content container-fluid">
          <div class="row align-items-center">
            <div class="col-12 col-md-6 order-2 order-md-1">
              <h1 class="banner__title">{{ $t('i18n.' + this.form.propertiesName + ".homeTitle") }}</h1>
              <p class="banner__text">{{ $t('i18n.' + this.form.propertiesName + ".titleText") }}</p>
            </div>
          </div>
        </div>
        <div class="banner__bg">
          <img :src="form.pathImg" />
        </div>
      </div>

      <div class="properties container-fluid">
        <div class="wp-block-columns">
          <div class="wp-block-column">
            <div class="properties-div">
              <span class="properties-text-title">{{ $t('i18n.' + this.form.propertiesName + ".title") }}</span>
            </div>
            <div class="properties-div">
              <span>{{ $t('i18n.properties.size') }}</span>&nbsp;&nbsp;
              <span class="properties-text">{{ $t('i18n.' + this.form.propertiesName + ".size") }}</span>
            </div>
            <div class="properties-div">
              <span>{{ $t('i18n.properties.driver') }}</span>&nbsp;&nbsp;
              <span class="properties-text" v-html="$t('i18n.' + this.form.propertiesName + '.driver')"></span>
            </div>
            <div class="properties-div">
              <span>{{ $t('i18n.properties.valveMaterialMaterial') }}</span>&nbsp;&nbsp;
              <span class="properties-text">{{ $t('i18n.' + this.form.propertiesName + ".valveMaterialMaterial") }}</span>
            </div>
            <div class="properties-div">
              <span>{{ $t('i18n.properties.feedingThrough') }}</span>&nbsp;&nbsp;
              <span class="properties-text">{{ $t('i18n.' + this.form.propertiesName + ".feedingThrough") }}</span>
            </div>
            <div class="properties-div" v-if="form.showFlg">
              <span>{{ $t('i18n.properties.StandardFlanges') }}</span>&nbsp;&nbsp;
              <span class="properties-text">{{ $t('i18n.' + this.form.propertiesName + ".StandardFlanges") }}</span>
            </div>
          </div>
          <div class="wp-block-column">
            <img :src="form.img" />
          </div>
        </div>
        <div class="row mt-6 mt-md-12">
          <div class="col-12">
            <div class="tabs-container">
              <div class="tabs-outer-wrapper --on-table">
                <div class="tabs-inner-wrapper">
                  <ul class="tabs">
                    <li class="tab" :class="{ '--active': tagFlg === 't' }" @click="changeTag('t')">
                      <span class="tab-link">{{ $t('i18n.technicalData') }}</span>
                    </li>
                    <li class="tab" :class="{ '--active': tagFlg === 'd' }" @click="changeTag('d')">
                      <span class="tab-link">{{ $t('i18n.downloadFile') }}</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="tabs-content">
                <div class="tab-content" :class="{ 'set-display': tagFlg !== 't' }">
                  <div class="tab-content-img">
                    <img :src="$t('i18n.https')+form.technicalImg"/>
                  </div>
                </div>
                <div class="tab-content" :class="{ 'set-display': tagFlg !== 'd' }">
                  <div class="summary-table --mobile-full-width">
                    <div class="summary-table__wrapper">
                      <a target="_blank" class="download-link --small  --thumb ">
                        <div class="download-link__thumb">
                          <img :src="form.downloadImg"/>
                        </div>
                        <div class="download-link__content mr-2">
                          <h4 class="download-link__title">
                            {{ $t('i18n.' + this.form.propertiesName + ".downloadTitle") }}
                          </h4>
                        </div>
                        <div class="ml-auto" style="display: flex">
                          <span class="badge mr-0p5 mr-md-1" v-hover="{ className: '--upper' }">{{ form.type }}</span>
                          <span class="badge mr-0p5 mr-md-1" v-hover="{ className: '--upper' }">{{ form.size }}</span>
                          <span class="download-link__download" @click="download"> {{ $t('i18n.download') }}</span>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid">
        <div class="row">
          <div class="col-12 footer-btn">
            <button class="va-btn" @click="goPageHome">{{ $t('i18n.backVacuum') }}</button>
            <button class="va-btn ml-auto" @click="goPageNext" :class="{'set-display': !form.isLast}">{{ $t('i18n.next') }}</button>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import {downloadFile} from "../api/api";
import {Message} from "element-ui";

export default {
  name: "VacuumValve",
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tagFlg: "t",
    }
  },

  // created() {
  //   this.goTop();
  // },
  mounted () {
    this.goTop();
  },
  activated() {
    console.log('xxxx')
    this.goTop();
  },
  methods: {
    download() {
      if (!this.$store.state.isLogin) {
        this.$router.push("login");
      }
      downloadFile({ id: this.form.id }, localStorage.getItem('token')).then(res => {
        if (res.data && res.data.code == '1') {
          // window.open("http://a34.madpay.com/" + res.data.data)
          window.open("https://www.jiashengvac.com/" + res.data.data)
          // window.open("http://admin.jiashengvac.com/" + res.data.data)
        } else if (res.data && res.data.code == '0') {
          Message({
            message: "暂无下载文件",
            // message: error.message,
            type: 'error',
            duration: 3 * 1000
          });
        } else {
          Message({
            message: res.data.msg,
            // message: error.message,
            type: 'error',
            duration: 3 * 1000
          });
          if (res.data.msg === "请重新登录") {
            this.$router.push("login")
          }
        }
      })
    },
    changeTag(val) {
      this.tagFlg = val;
    },
    goPageHome() {
      this.$emit('goPageHome');
    },
    goPageNext() {
      this.$emit('goPageNext');
    },
    goTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' }); // 平滑滚动到顶部
      // document.querySelector('#topDom').scrollIntoView({
      //   behavior: 'smooth'
      // })
    }
  },
}
</script>

<style scoped>

.section.--banner, .section.--main-slider {
  padding: 0;
  max-width: 100vw;
  overflow-x: hidden;
}
.banner {
  width: 100%;
  height: 61rem;
  align-items: center;
  display: flex;
  background-image: url(../assets/imgs/zkfBg.png);
  background-size: cover; /* 保证背景图片覆盖元素并且不变形 */
  background-position: center; /* 将背景图片居中显示 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  padding: 0 18rem 0 28rem;
}
.banner__bg {
  /* position: absolute;
  width: 100%;
  height: 64rem; */
}
.banner__bg {
  z-index: 1;
}

.banner__bg img {
  /* max-width: 100%; */

  display: block;
  width: 100%;
  /* height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  -o-object-position: 50% 50%;
  object-position: 50% 50%; */
}
img {
  max-width: 100%;
}
.banner__content {
  position: relative;
  z-index: 2;
}
.banner__title {
  font-size: 4rem;
  letter-spacing: -.084rem;
  line-height: 6rem;
  margin-bottom: 2rem;
  padding-right: 2rem;
  color: #FFFFFF;
  font-weight: 500;
}
.banner__text {
  margin-top: 3rem;
  font-size: 2.1rem;
  letter-spacing: -.022rem;
  line-height: 4rem;
  padding-right: 2rem;
  color: #FFFFFF;

  font-weight: 500;
}

.breadcrumb {
  display: flex;
  height: 8rem;
  align-items: center;
  position: absolute;
  z-index: 80;
  left: 5rem;
  margin: 0;
  padding: 0;
}
.breadcrumb__li {
  position: relative;
  padding-right: 2.5rem;
  margin-right: 2rem;
}
.breadcrumb__link {
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #e3e3e3;
  letter-spacing: 0;
  display: block;
  max-width: 20rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.breadcrumb__li.--current:after {
  content: "";
  width: 0.6rem;
  height: 1rem;
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -0.3rem;
  background: url(../assets/imgs/arrow-breadcrumb.svg) no-repeat 50%;
}
.breadcrumb__li:last-child {
  padding-right: 0;
  margin-right: 0;
}
.breadcrumb__text {
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #EEEEEE;
  letter-spacing: 0;
  display: block;
  max-width: 20rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.properties {
  margin-top: 10rem;
  margin-bottom: 10rem;
  color: #800080;
  font-weight: normal;
  line-height: 3rem;
  font-size: 2.2rem;
}
.properties-div {
  margin-bottom: 2rem;
}
.properties-text-title {
  font-size: 3rem;
}
.properties-text {
  color: #000000;
}

.wp-block-columns {
  display: flex;
  margin-bottom: 28px;
  flex-wrap: wrap;
}
.wp-block-columns .wp-block-column:first-child {
  padding-right: 2rem;
}
.wp-block-columns .wp-block-column {
  margin: 0 1.5rem!important;
  font-size: 1.6rem;
}
.wp-block-columns .wp-block-column:last-child {
  padding-left: 2rem;
}
.tabs-outer-wrapper.--on-table .tabs-inner-wrapper {
  justify-content: flex-start;
}
.tabs-inner-wrapper {
  display: flex;
  justify-content: center;
  position: relative;
}
.tabs {
  display: flex;
  position: relative;
}
.tab:first-child {
  padding-right: 0.2rem;
}
.tab.--active .tab-link {
  color: #800080;
}
.tab-link {
  background-color: #97979781;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 5rem;
  padding: 0 3rem;
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 2.3rem;
  color: rgba(255, 255, 255, 0.712);
  cursor: pointer;
  position: relative;
  letter-spacing: -.02rem;
  white-space: nowrap;
  transition-property: color;
  transition-duration: .3s;
}
.tab-link:after {
  content: "";
  position: absolute;
  width: 100%;
  background: #fff;
  height: 0.1rem;
  bottom: -0.1rem;
  left: 0;
  display: block;
  z-index: 2;
  filter: alpha(opacity = 0);
  -moz-opacity: 0;
  -khtml-opacity: 0;
  opacity: 0;
}
.tabs-content {
  position: relative;
  z-index: 1;
  margin-top: -0.1rem;
}
.tab-content:first-child {
  display: block;
}
.tab-content-img {
  width: 100%;
}
.set-display {
  display: none !important;
}
.summary-table {
  width: 100%;
  padding: 5rem;
  border: 0.1rem solid #e6e6e6;
  border-radius: 0.4rem;
}
.download-link.--small {
  height: 6rem;
}
.download-link {
  display: flex;
  width: 100%;
  align-items: center;
  min-height: 8rem;
  padding: 1rem 2rem 1rem 0;
  position: relative;
  cursor: pointer;
  border-bottom: 0.1rem solid #ededed;
  transition: all .2s ease-in-out;
}
.download-link__thumb {
  width: 7rem;
  height: 7rem;
  padding: 1rem;
  margin-right: 2rem;
  position: relative;
  border: 0.1rem solid #e6e6e6;
  background: #fff;
  border-radius: 0.4rem;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  box-shadow: 0 0.2rem 0.4rem 0 rgba(0,0,0,.05);
  transition: all .2s ease-in-out;
}
.download-link__thumb img {
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
}
.download-link__content {
  display: flex;
  align-items: center;
}
.download-link__title {
  font-size: 1.6rem;
  font-weight: 500;
  color: #000;
  display: block;
  letter-spacing: -.018rem;
  line-height: 3rem;
  margin: 0;
}
.badge.--upper {
  text-transform: uppercase;
}
.badge {
  border: .1rem solid #e6e6e6;
  height: 3rem;
  display: flex;
  align-items: center;
  white-space: nowrap;
  font-weight: 500;
  font-size: 1.1rem;
  color: #4c4c4c;
  letter-spacing: .03rem;
  padding: 0 1.5rem;
  cursor: pointer;
  border-radius: 2rem;
}
.download-link__download {
  font-size: 1.6rem;
  font-weight: 500;
  color: #800080;
  letter-spacing: -.018rem;
  line-height: 3rem;
  padding-right: 2rem;
  position: relative;
}
.footer-btn {
  display: flex;
  margin-bottom: 6rem;
}
.va-btn {
  height: 5rem;
  width: 14rem;
  border: 2px solid #ededed;
  border-radius: 10%;
  background-color: white;
  color: #800080;
  font-size: 16px;
  font-weight: 600;
}
@media (max-width: 1023.9px) {
  .summary-table {
    padding: 3rem;
    overflow: auto;
    width: calc(100% + 3rem);
    margin-left: -1.5rem;
  }
  .summary-table.--mobile-full-width .summary-table__wrapper {
    min-width: 100%;
    max-width: 100%;
    padding-right: 0;
    margin: 0;
  }
  .download-link.--small {
    height: auto;
    padding: 2rem 1.5rem;
    flex-wrap: wrap;
    width: calc(100% + 3rem);
    margin-left: -1.5rem;
  }
  .download-link__thumb {
    width: 5rem;
    height: 5rem;
    min-width: 5rem;
  }
  .download-link__title {
    line-height: 2.6rem;
    margin-bottom: 1rem;
  }
  .va-btn {
    width: 14rem;
  }
}

@media (max-width: 768px) {
  .banner {
    padding: 0;
  }
  .banner__bg {
    padding-right: 10px;
  } 
  .banner__bg {
    padding-right: 10px;
  }
  .banner__title {
    font-size: 16px;
    font-weight: bold;
    line-height: 1;
  }
  .banner__text {
    padding-right: 0px;
    margin-top: 20px;
    width: 180px;
    font-size: 14px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    /* // 超出几行省略 */
    -webkit-line-clamp: 10;  
    overflow:hidden;    
  }
  .breadcrumb {
    left: 2rem;
  }
  .breadcrumb__link {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/VacuumValve.vue